module.exports = __webpack_public_path__ + "img/horizontal_3_4_pp12_9006.dd5a4ac8.png";